module.exports = __webpack_public_path__ + "img/boli@3x.adf0f9d7.png";